import type { SiteShellProps } from "@site-types/components/siteShell"
import { RouteShellContextProvider, resolveRouteShellState, useRouteShellPathname } from "@components/routeShellContext"
import BackButtonComponent from "./BackButton"
import Background from "./Background"
import BigHeadingComponent from "./BigHeading"
import Footer from "./Footer"
import Main from "./Main"
import SideMenu from "./SideMenu"

export function SiteShell({ children, page, title }: SiteShellProps) {
  const pathname = useRouteShellPathname()
  const shellState = resolveRouteShellState({ page, pathname })

  const content = (
    <>
      {title ? <BigHeadingComponent>{title}</BigHeadingComponent> : null}
      {children}
    </>
  )

  return (
    <RouteShellContextProvider
      page={page}
      pathname={pathname}
    >
      <div className="site-shell">
        <SideMenu />
        <Main>
          {shellState.currentPage === "index"
            ? content
            : <div className={`page-container page-${shellState.pageClass}`}>{content}</div>}
          {shellState.currentPage !== "index" ? <Footer /> : null}
        </Main>
        <Background />
      </div>
    </RouteShellContextProvider>
  )
}

export const BigHeading = BigHeadingComponent

export const BackButton = BackButtonComponent
